var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mapboxgl-ctrl mapboxgl-ctrl-group",
      attrs: { id: "mapLegend" }
    },
    [
      _c("div", { staticClass: "legend-group" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "legend-list" },
          _vm._l(_vm.groups.zoning.rows, function(row, index) {
            return _c("div", { key: row.label, staticClass: "legend-row" }, [
              _c("span", {
                staticClass: "legend-swatch",
                style: _vm.swatchStyle(row)
              }),
              _vm._v(" "),
              _c("span", { staticClass: "legend-label" }, [
                _vm._v("\n\t\t\t\t\t" + _vm._s(row.label) + "\n\t\t\t\t")
              ])
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm._m(1)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend-header" }, [
      _c("i", { staticClass: "material-icons md-14" }, [
        _vm._v("remove_red_eye")
      ]),
      _vm._v("\n\t\t\tzoning\n\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend-group off" }, [
      _c("div", { staticClass: "legend-header" }, [
        _c("i", { staticClass: "material-icons md-14" }, [
          _vm._v("remove_red_eye")
        ]),
        _vm._v("\n\t\t\toverlays\n\t\t")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d9615c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d9615c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/map-legend.vue
// module id = null
// module chunks = 